import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';
import { EFavoritesType } from 'lib/types';
import { FavouritesType } from 'lib/dictionary';

const useChangeTypeFavoriteList = (
  id: number,
  payload: { type: EFavoritesType; copyToMyself: boolean; userIds: number[] },
) => {
  async function fetchChangeTypeFavoriteList(url: string) {
    try {
      const data = await fetcher.patch(url, { ...payload });
      if (data?.error) {
        return toast.error(
          `Не удалось создать ${FavouritesType.label(payload.type)} список: ${data?.error}`,
          { autoClose: 5000 },
        );
      }
      toast.success(`${FavouritesType.label(payload.type)} список создан`, { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error(`Не удалось создать ${FavouritesType.label(payload.type)} список`, {
        autoClose: 5000,
      });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/${id}/change-type`,
    fetchChangeTypeFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useChangeTypeFavoriteList;
